/**
 *@author   tonicli
 *@date     2016/6/5
 */
import { globalObject } from '@tencent/vft-common/system';

import env from './env';

function _toString(v) {
  return Object.prototype.toString.call(v);
}

function _isObject(v) {
  return _toString(v) === '[object Object]';
}

function _trim(v) {
  if (_toString(v) !== '[object String]') {
    return v;
  }
  return v.replace(/^\s+|\s+$/g, '');
}

/**
  * 获取 http 协议
  * @returns {String}
  */
function getProtocol() {
  return globalObject.location?.protocol || 'https:';
}

function _buildUrl(url, params, useEncode) {
  let queryStr = '';

  if (!url) {
    throw new Error('[util.url.buildUrl]url is required');
  }
  if (!params || params === null) {
    return url;
  }
  queryStr = _buildParams(params, useEncode);
  if (!queryStr || !queryStr.length) {
    return url;
  }

  const protocol = getProtocol();
  if (url.indexOf('//') === 0) url = protocol + url;

  return [url, url.indexOf('?') > -1 ? '&' : '?', queryStr].join('');
}

function _buildParams(params, useEncode, strictMode) {
  let v;
  let query;
  const r = [];
  Object.keys(params).forEach((k) => {
    v = params[k];
    query = _buildParam(k, v, useEncode, strictMode);
    if (query !== null && query !== '') {
      r.push(query);
    }
  });
  return r.join('&');
}

function _buildParam(k, v, useEncode, strictMode = true) {
  const type = typeof v;
  let i = 0;
  let len;
  let r = [];

  // 默认是严格模式，过滤空值
  if (v === '' && strictMode) {
    return '';
  }
  if (type === 'number' || type === 'string' || type === 'boolean') {
    return [k, useEncode ? encodeURIComponent(v) : v].join('=');
  }
  if (_isObject(v)) {
    Object.keys(v).forEach((prop) => {
      r.push(_buildParam([k, '[', prop, ']'].join(''), v[prop], useEncode, strictMode));
    });
  } else if (Array.isArray(v)) {
    for (len = v.length; i < len; i++) {
      r.push(_buildParam([k, '[', i, ']'].join(''), v[i], useEncode, strictMode));
    }
  }
  // 过滤null, undefined, ''
  r = r.filter(item => item !== null && _trim(item) !== '');
  return r.length ? r.join('&') : '';
}

/**
  *@desc 将url格式化为标准格式
  *@param url
  *@param [useRelative]  是否转为相对协议，默认为true
  *@param [protocol]     强制转为指定协议，如果useRelative为false，并且未指定protocol，则取当前页面的protocol
  */
function _normalize(url, useRelative = true, protocol) {
  const absUrl = _abs(url);
  // 仅处理http,https协议
  if (!/^(http:|https:)/.test(absUrl)) {
    return url;
  }
  if (
    arguments.length === 2
    && typeof useRelative === 'string'
    && useRelative.length > 0
  ) {
    protocol = useRelative;
    useRelative = false;
  }
  if (useRelative) {
    return absUrl.replace(/^(http:|https:)/, '');
  }
  if (!protocol) {
    protocol = getProtocol();
  }
  if (!/:$/.test(protocol)) {
    protocol += ':';
  }
  return absUrl.replace(/^\w+:/, protocol);
}

function _abs(url) {
  if (env.isCSR) {
    return url;
  }
  const el = document.createElement('a');
  el.href = url;
  return el.href;
}

function _getHost(url) {
  const absUrl = _abs(url);
  let match;

  let oUrl;

  let host = '';

  if (typeof URL !== 'undefined') {
    try {
      oUrl = new URL(absUrl);
      host = oUrl.host;
    } catch (e) {}
  }
  if (!host) {
    match = url.match(/^[\w^_]+:\/\/([\w.-]+)/);
    host = match && match.length > 1 ? match[1] : '';
  }

  return host;
}

export {
  _abs as abs,
  _buildParams as buildQueryStr,
  _buildUrl as buildUrl,
  _getHost as getHost,
  _normalize as normalize,
};

